import { render, staticRenderFns } from "./robots.vue?vue&type=template&id=d9fd8e2a&"
import script from "./robots.vue?vue&type=script&lang=js&"
export * from "./robots.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\svn\\家用后台\\branches\\20240430-1.5.0\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d9fd8e2a')) {
      api.createRecord('d9fd8e2a', component.options)
    } else {
      api.reload('d9fd8e2a', component.options)
    }
    module.hot.accept("./robots.vue?vue&type=template&id=d9fd8e2a&", function () {
      api.rerender('d9fd8e2a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/robot/medical/robot/robots.vue"
export default component.exports